export const nb = {
  app: {
    name: 'Alkisen',
    tagline: 'Kjelleren i orden. Baren klar.',
    motto: 'Skann · plasser · miks · skål',
  },
  nav: {
    cellar: 'Kjeller',
    scan: 'Skann',
    nyheter: 'Nyheter',
    utforsk: 'Utforsk',
    popular: 'Populært',
    wishlist: 'Ønskeliste',
    feed: 'Aktivitet',
    friends: 'Venner',
    stats: 'Statistikk',
    guides: 'Guides',
    racks: 'Hyller',
    occasions: 'Anledninger',
    pair: 'Mat-paring',
    recommend: 'Anbefalinger',
    labels: 'Etiketter',
    vinliste: 'Vinliste',
    pricing: 'Prisautomat',
    bestilling: 'Bestilling',
    varetelling: 'Varetelling',
    pos: 'POS-integrasjon',
    profil: 'Offentlig side',
    historikk: 'Historikk',
    abonnement: 'Abonnement',
    settings: 'Innstillinger',
    signOut: 'Logg ut',
    signIn: 'Logg inn',
    scans: 'Skanninger',
    admin: 'Admin',
  },
  navGroups: {
    discover: 'Oppdag',
    plan: 'Planlegg',
    social: 'Sosialt',
    tools: 'Verktøy',
  },
  landing: {
    heroTitle: 'Alkisen holder flaskene på stell.',
    heroSubtitle: 'Norsk produktdata først. Når katalogen ikke dekker alt, bruker Alkisen smarte backup-kilder for vin, sprit og cocktails.',
    cta: 'Åpne baren',
    ctaSecondary: 'Si mer',
    feat1Title: 'Snap & vit alt',
    feat1Body: 'Pek kamera mot etiketten — vin, øl eller sprit — og vi henter produsent, type, opphav og årgang automatisk.',
    feat2Title: 'Strekkode på et blunk',
    feat2Body: 'Skann strekkoden og match mot primærkatalogen først. Backup-kilder dekker flasker som faller utenfor.',
    feat3Title: 'Etiketter med stil',
    feat3Body: 'Print pene QR-/strekkode-etiketter til Zebraen. Kjelleren ser ut som en hotellbar.',
    feat4Title: 'Mat-paring',
    feat4Body: 'Hva skal du spise? Kjøtt, fisk, kylling eller vegetar — vi foreslår vin, øl eller sprit fra kjelleren din eller katalogen.',
    feat5Title: 'Drink-miks',
    feat5Body: 'Vi ser hva du har og foreslår cocktails. Vi sier også hva som mangler — så du vet hva du må kjøpe før neste fest.',
    feat6Title: 'Guides',
    feat6Body: 'Tørk appelsinskiver, lag enkel sirup, plukk riktige isbiter. Korte how-to-guider rett i appen, akkurat når du trenger dem.',
    sectionFeatures: 'Bygd for alle som digger en god drink',
    sectionStats1: 'Katalogprodukter',
    sectionStats2: 'Strekkodeprovidere',
    sectionStats3: 'Sekunders skanning',
    footer: 'Laget med kjærlighet, koffein og en og annen Negroni.',
  },
  cellar: {
    title: 'Kjelleren',
    subtitle: '{{count}} flasker · sortert {{sort}}',
    addBottle: 'Legg til flaske',
    empty: 'Kjelleren er tom',
    emptyHint: 'Skann en flaske eller søk i katalogen for å starte.',
    searchPlaceholder: 'Søk i kjelleren...',
    filters: {
      all: 'Alle',
      red: 'Rødvin',
      white: 'Hvitvin',
      sparkling: 'Musserende',
      rose: 'Rosé',
      dessert: 'Dessert',
      fortified: 'Sterkvin',
      drinkSoon: 'Drikkes snart',
      unread: 'Uvurdert',
    },
    sort: {
      addedDesc: 'Nyest først',
      addedAsc: 'Eldst først',
      nameAsc: 'Navn A→Å',
      ratingDesc: 'Best vurdert',
      vintageDesc: 'Nyeste årgang',
    },
    tabs: {
      cellared: 'I kjelleren',
      drunk: 'Drukket',
      gifted: 'Bortgitt',
    },
  },
  scan: {
    title: 'Skann',
    subtitle: 'Strekkode, QR eller etikettbilde — vi finner riktig flaske.',
    auto: 'Auto',
    barcode: 'Strekkode',
    qr: 'QR',
    photo: 'Etikettfoto',
    cameraPermissionTitle: 'Vi trenger kameratillatelse',
    cameraPermissionBody: 'For å skanne strekkoder eller etiketter, gi tilgang til kameraet.',
    cameraSecureContextBody: 'Kamera krever HTTPS eller localhost. Åpne appen via https://vin.invested.no når Traefik-ruten er aktiv.',
    cameraStart: 'Start kamera',
    cameraStop: 'Stopp kamera',
    awaitingCode: 'Hold flasken stille så snart strekkoden er synlig.',
    awaitingPhoto: 'Posisjoner etiketten i rammen og trykk for å ta bilde.',
    capture: 'Ta bilde',
    upload: 'Eller last opp',
    resolveTitle: 'Resultat',
    resolveMappedTitle: 'Vi kjenner denne flasken',
    resolveCandidatesTitle: 'Velg riktig produkt',
    resolveAiTitle: 'AI-tolket etikett',
    confirm: 'Bekreft denne',
    notFound: 'Vi fant ingen treff. Søk manuelt:',
    addManually: 'Legg til manuelt',
    noneMatch: 'Ingen passer?',
    photoStack: 'Skannet etiketter',
    bulkLabels: 'Bulk etikettskanning',
    bulkLabelsDesc: 'Velg eller slipp mange etikettbilder — AI leser og finner katalogtref for hvert',
  },
  scanBulkLabels: {
    title: 'Bulk etikettskanning',
    subtitle: 'Velg eller slipp mange etikettbilder — vi analyserer hvert enkelt og finner katalogtref.',
    dropHint: 'Slipp bilder her, eller velg fra enhet',
    analyzeAll: 'Analyser alle',
    addAllMatches: 'Legg til alle treff',
    analyzing: 'Analyserer…',
    noPictures: 'Ingen bilder valgt',
    noPicturesHint: 'Velg eller slipp etikettbilder over for å starte.',
    retryItem: 'Prøv igjen',
    retryAllFailed: 'Prøv alle som feilet',
  },
  duplicate: {
    title: 'Allerede i kjelleren',
    body: '«{{name}}» ser ut til å ligge i kjelleren fra før.',
    addAnother: 'Legg til én til',
    otherVintage: 'Annen årgang',
    skip: 'Hopp over (duplikat)',
    vintageLabel: 'Bekreft eller endre årgangen',
  },
  bottle: {
    backToCellar: 'Tilbake til kjelleren',
    rateThis: 'Vurder denne',
    yourRating: 'Din vurdering',
    notes: 'Notater',
    placeholderNotes: 'Hva tenkte du om denne? Aroma, smak, finish...',
    save: 'Lagre',
    saved: 'Lagret',
    similar: 'Lignende viner',
    sales: 'Salg siste 12 mnd',
    addLabel: 'Legg til i etikettkøen',
  },
  racks: {
    title: 'Hyller',
    subtitle: 'Dra flaskene mellom hyllene og spaltene.',
    new: 'Ny hylle',
    layout: 'Oppsett',
    rows: 'Rader',
    cols: 'Spalter',
  },
  occasions: {
    title: 'Anledninger',
    subtitle: 'Spillelister av flasker for ulike kvelder.',
    new: 'Ny anledning',
    bbq: 'BBQ',
    christmas: 'Julemiddag',
    tuesday: 'Tirsdag-rødt',
    anniversary: 'Bryllupsdag',
    party: 'Fest',
  },
  labels: {
    title: 'Etiketter',
    subtitle: 'Bygg, forhåndsvis og print.',
    queue: 'Print-kø',
    new: 'Ny etikett',
    preview: 'Forhåndsvis',
    print: 'Print',
    reprint: 'Print igjen',
    retryPrint: 'Prøv igjen',
    duplicate: 'Dupliser',
    delete: 'Slett',
    pause: 'Pause',
    resume: 'Fortsett',
    clearCompleted: 'Fjern ferdige',
    fields: {
      productName: 'Produktnavn',
      cuvee: 'Cuvée',
      producer: 'Produsent',
      vintage: 'Årgang',
      region: 'Område',
      country: 'Land',
      wineClass: 'Klasse',
      typeCode: 'Type',
      valueRange: 'Prisklasse',
      foodPairings: 'Mataparing',
      occasion: 'Anledning',
      barcode: 'Strekkode',
    },
    statuses: {
      pending: 'Venter',
      queued: 'I kø',
      printing: 'Printer',
      printed: 'Printet',
      completed: 'Ferdig',
      done: 'Ferdig',
      failed: 'Feilet',
      paused: 'Pause',
      cancelled: 'Kansellert',
    },
  },
  pricing: {
    title: 'Prisautomat',
    subtitle: 'Sett innkjøpspris og salgspris for kjellerens flasker — {{count}} flasker',
    tabPricing: 'Prising',
    tabQuantity: 'Antall & plassering',
    tabHistory: 'Historikk',
    tabDetails: 'Detaljer',
    purchasePriceExVat: 'Kjøpspris eks. mva',
    purchasePriceIncVat: 'Kjøpspris ink. mva',
    sellingPrice: 'Salgspris',
    lockPrice: 'Lås salgspris',
    lockPriceHint: 'Prisautomaten rører aldri en låst pris',
    marketPrice: 'Markedspris (katalog)',
    marketPriceUpdated: 'oppdatert {{date}}',
    marketPriceNone: 'Ingen katalogpris funnet',
    suggestedPrice: 'Foreslått pris',
    applySuggested: 'Bruk foreslått',
    sellBuyRatio: 'Sell/buy-ratio',
    costOfGoods: 'Kostprosent',
    surcharge: 'Påslag',
    glassPrice: 'Pris per glass',
    glassSize: 'Glasstørrelse',
    soldByGlass: 'Selges i glass',
    supplier: 'Leverandør',
    noBasis: 'Sett kjøpspris for å beregne',
    columns: {
      name: 'Navn',
      purchase: 'Kjøpspris',
      market: 'Markedspris',
      selling: 'Salgspris',
      suggested: 'Foreslått',
      ratio: 'Ratio',
      glass: 'Glass',
    },
    bulk: {
      selected: '{{count}} valgt',
      applySuggestedToSelected: 'Bruk foreslått pris på valgte',
      applyMarkupToSelected: 'Sett påslag på valgte',
      markupPlaceholder: 'F.eks. 2.8',
      apply: 'Bruk',
      updated: '{{count}} priser oppdatert',
      skippedLocked: '{{count}} låste flasker ble hoppet over',
    },
    empty: 'Ingen flasker i kjelleren ennå',
    quantity: {
      qty: 'Antall',
      rack: 'Plassering',
      noRack: 'Uten plassering',
      location: 'Lokasjon',
      pendingDelivery: 'Venter på levering',
      pendingDeliveryHint: 'Bestilt/på vei, men ikke fysisk plassert ennå',
    },
    history: {
      empty: 'Ingen historikk ennå',
      events: 'Hendelser',
      eventsEmpty: 'Ingen registrerte hendelser ennå',
      remaining: '{{qty}} igjen',
      tastingNotes: 'Smaksnotater',
      tastingNote: 'Smaksnotat',
      drunkAt: 'Drukket',
    },
    sell: {
      action: 'Selg',
      title: 'Selg flaske',
      quantity: 'Antall',
      unitPrice: 'Pris per flaske',
      note: 'Notat',
      confirm: 'Bekreft salg',
      success: 'Salg registrert',
      partial: 'Kun {{applied}} av {{requested}} flasker var på lager',
    },
    marketValue: {
      title: 'Markedsverdi',
      none: 'Ingen prishistorikk funnet ennå',
      updated: 'oppdatert {{date}}',
      trend: {
        up: 'Stigende',
        down: 'Fallende',
        flat: 'Uendret',
      },
      crossMarket: 'Andre kilder',
      crossMarketEmpty: 'Ingen treff i andre kilder',
      confidence: {
        ean: 'Strekkode-match',
        name_vintage: 'Navn/årgang-match',
      },
    },
  },
  orders: {
    title: 'Bestilling',
    subtitle: '{{count}} bestillinger',
    new: 'Ny bestilling',
    empty: 'Ingen bestillinger ennå',
    noSupplier: 'Uten leverandør',
    supplier: 'Leverandør',
    note: 'Notat',
    addLine: 'Legg til vare',
    searchCatalog: 'Søk i katalogen...',
    lineName: 'Navn',
    quantity: 'Antall',
    unitPrice: 'Enhetspris',
    addLineButton: 'Legg til linje',
    noLines: 'Ingen linjer ennå',
    total: 'Totalt',
    place: 'Bestill',
    placed: 'Bestilling sendt',
    markReceived: 'Marker mottatt',
    confirmReceived: 'Bekreft mottatt',
    receiveHint: 'Velg hvor flaskene skal plasseres (valgfritt).',
    received: 'Bestilling mottatt',
    cancel: 'Kanseller',
    cancelled: 'Bestilling kansellert',
    orderedAt: 'Bestilt {{date}}',
    receivedAt: 'Mottatt {{date}}',
    status: {
      draft: 'Utkast',
      ordered: 'Bestilt',
      received: 'Mottatt',
      cancelled: 'Kansellert',
    },
  },
  stockCount: {
    title: 'Varetelling',
    subtitle: '{{count}} tellinger',
    new: 'Ny telling',
    empty: 'Ingen tellinger ennå',
    noLines: 'Ingen flasker matcher søket',
    searchPlaceholder: 'Søk i tellingen...',
    applySwitch: 'Ny telling blir kjellerbeholdning',
    applySwitchHint: 'Når tellingen fullføres, oppdateres flaskenes antall til det som er talt',
    progress: '{{done}} av {{total}} bekreftet',
    complete: 'Fullfør',
    completed: 'Varetelling fullført',
    adjusted: '{{count}} flasker justert',
    exportPdf: 'Eksporter PDF',
    unassigned: 'Uplassert',
    decrease: 'Reduser antall',
    increase: 'Øk antall',
    confirmLine: 'Bekreft linje',
    columns: {
      wine: 'Vin',
      vintage: 'Årgang',
      volume: 'Volum',
      purchasePrice: 'Kjøpspris',
      location: 'Plassering',
      cellar: 'Kjeller',
      newCount: 'Ny telling',
    },
    status: {
      open: 'Åpen',
      completed: 'Fullført',
    },
  },
  pos: {
    title: 'POS-integrasjon',
    subtitle: 'Koble et kassasystem til Alkisen — hver solgte flaske trekkes automatisk fra kjelleren.',
    keys: {
      title: 'API-nøkler',
      new: 'Ny nøkkel',
      namePlaceholder: 'F.eks. Kasse 1',
      empty: 'Ingen API-nøkler ennå',
      created: 'Nøkkel opprettet',
      createdHint: 'Kopier nøkkelen nå — den vises aldri igjen.',
      copy: 'Kopier',
      copied: 'Kopiert',
      revoke: 'Tilbakekall',
      revoked: 'Tilbakekalt',
      revokeConfirm: 'Tilbakekall denne nøkkelen? Kassasystemer som bruker den vil ikke lenger kunne rapportere salg.',
      lastUsed: 'Sist brukt {{date}}',
      neverUsed: 'Aldri brukt',
      createdAt: 'Opprettet {{date}}',
    },
    docs: {
      title: 'Integrasjon',
      description: 'POST hver solgte flaske til endepunktet under, autentisert med API-nøkkelen i headeren.',
      endpoint: 'Endepunkt',
      header: 'Header',
      example: 'Eksempel',
      fields: 'externalId er en idempotensnøkkel — samme externalId to ganger behandles kun én gang. Match på bottleId, catalogId eller name (i den rekkefølgen).',
    },
    recentSales: {
      title: 'Nylige salg',
      empty: 'Ingen POS-salg registrert ennå',
    },
  },
  history: {
    title: 'Kjellerhistorikk',
    subtitle: 'Full logg over alt som skjer i kjelleren.',
    empty: 'Ingen hendelser ennå',
    filters: {
      all: 'Alle',
    },
    columns: {
      date: 'Dato',
      activity: 'Hendelse',
      wine: 'Vin',
      bottles: 'Flasker',
      remaining: 'Gjenstår',
      buy: 'Kjøp',
      sell: 'Salg',
    },
    activity: {
      added: 'Lagt til',
      drunk: 'Drukket',
      gifted: 'Bortgitt',
      sold: 'Solgt',
      adjusted: 'Justert',
      moved: 'Flyttet',
      received: 'Mottatt',
      counted: 'Talt',
    },
  },
  settings: {
    title: 'Innstillinger',
    language: 'Språk',
    languageNb: 'Norsk',
    languageEn: 'English',
    theme: 'Tema',
    apiKeys: 'API-nøkler',
    catalog: 'Katalog',
    syncCatalog: 'Synk katalog',
    members: 'Medlemmer',
    aboutTitle: 'Om Alkisen',
  },
  common: {
    loading: 'Laster...',
    error: 'Noe gikk galt',
    retry: 'Prøv igjen',
    cancel: 'Avbryt',
    save: 'Lagre',
    close: 'Lukk',
    confirm: 'Bekreft',
    delete: 'Slett',
    add: 'Legg til',
    none: 'Ingen',
    optional: 'valgfritt',
    yes: 'Ja',
    no: 'Nei',
  },
};
